export default "__VITE_ASSET__4XeVkLC6__"